import { render } from "./StatusText.vue?vue&type=template&id=6e68b2a6&scoped=true"
import script from "./StatusText.vue?vue&type=script&lang=js"
export * from "./StatusText.vue?vue&type=script&lang=js"

import "./StatusText.vue?vue&type=style&index=0&id=6e68b2a6&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e68b2a6"]])

export default __exports__